// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"740a8e0f","229":"5bed6075","250":"20782704","329":"7363df80","377":"05309b4c","576":"a2116d4e","757":"3e26331e"}[chunkId] + ".chunk.js";
};